import React from 'react';

import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

const Text12week = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="Text12week">
      {S.space}
      <div className="bottom-text">
        <span>{t('clientConnect.sectionsDescriptionPart1')}</span> {t('clientConnect.section7DescriptionPart2')}
      </div>
    </div>
  );
};

export default Text12week;
